import { render, staticRenderFns } from "./userGroupsEditList.vue?vue&type=template&id=1fd08126&"
import script from "./userGroupsEditList.vue?vue&type=script&lang=js&"
export * from "./userGroupsEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports